'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import { ajaxRequest } from './ajax.js'

/**
 * React component for a login form popup to allow logging in without reloading the page.
 */
class LoginPopup extends React.Component {

  loginComplete = (result, status) => {

    // Remove the login form.
    ReactDOM.unmountComponentAtNode(this.props.popup_element);
    document.body.removeChild(this.props.popup_element);

    // Retry the failed request.
    ajaxRequest(this.props.failed_ajax_request)

    // If a popup window was opened, close it now.
    if (typeof(this.popup_window) != 'undefined') {
      this.popup_window.close();
    }
  }

  loginPressed = (event) => {
    event.preventDefault();
    this.popup_window = window.open('/login/?next=/accounts/login-ajax-complete/');
  }

  render() {
    return (
      <div style={{position: 'fixed', top: '0', bottom: '0', right: '0', left: '0', background: 'rgba(0, 0, 0, 0.9)', zIndex: '200', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        <div style={{background: 'white', padding: '0 15px', margin: '15px auto', width: '300px'}}>
          <h2>Log back in</h2>
          <p>It looks like you have been logged out of Xhale. Please click the button below to log in again from another window.</p>
          <p><a href="#" className="button login" onClick={this.loginPressed}>Log back in</a></p>
        </div>
      </div>
    );
  }
}

/**
 * Function to call to display a login popup after a failed ajax call.
 *
 * @param {object} failed_ajax_request - A jQuery ajax object that can be retried after login.
 */
var displayLoginPopup = function (failed_ajax_request) {
  var popup_container = document.createElement('div');
  document.body.appendChild(popup_container);
  window.login_popup = ReactDOM.render(<LoginPopup popup_element={popup_container} failed_ajax_request={failed_ajax_request} />, popup_container);
}

/**
 * An error callback function for AJAX requests that displays a login popup
 * when the user has been logged out.
 */
export var handleLoggedOutError = function (response, status, request_parameters) {
  if (status == 401) {
    return displayLoginPopup(request_parameters);
  }
}

export var handleAccessDeniedError = function (status) {
  if (status == 403) {
    return 'There was a problem saving. You do not appear to have access to edit this session.';
  }
}

export var handleNotFoundError = function (status) {
  if (status == 404) {
    return 'There was a problem saving. This session may have been removed by you or someone else with access since loading this page.';
  }
}

export var handleRemainingServerErrors = function (status) {
  return 'There was a problem saving. Please contact Xhale support if you continue to experience problems.';
}

export var handleNoConnectionError = function (status) {
  if (status == 0) {
    return 'There was a problem connecting to the server. This is likely because of a problem with the internet connection. Please try again.';
  }
}

export var handleAjaxErrors = function (response, status, error_message_callback) {

  // Logged out errors need to be dealt with separately otherwise the
  // original request will be missing and we won't be able to try the save
  // again. But if that error comes up we need to avoid the other error
  // handlers below from running so the user doesn't see a generic error
  // message too.
  if (status == 401) {
    return
  }

  var error_message = handleNoConnectionError(status);
  if (error_message) {
    error_message_callback(error_message, true);
    return;
  }

  var error_message = handleNotFoundError(status);
  if (error_message) {
    error_message_callback(error_message, false);
    return;
  }

  var error_message = handleAccessDeniedError(status);
  if (error_message) {
    error_message_callback(error_message, false);
    return;
  }

  var error_message = handleRemainingServerErrors(status);
  if (error_message) {
    error_message_callback(error_message, false);
    return;
  }

}
